import React, { useContext, useEffect, useState } from "react";
import { Text } from "rizzui/typography";
import { Radio } from "rizzui/radio";
import { useModal } from "../hooks/useModal";
import { ActionIcon } from "rizzui/action-icon";
import axios from "axios";
import { useNavigate } from "react-router";
import { AuthContext } from "../context/authContext";
import { baseUrl } from "../modules/account/login";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotifcication } from "../hooks/useNotification";
import { labelClassName } from "../modules/projects/new/first";
import { useLocation } from "react-router";

export default function ReviewContact({ overrideKey, details }) {
  const { closeModal, view } = useModal();
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const queryClient = useQueryClient();
  const { openNotification } = useNotifcication();
  const [option, setOption] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();

  // ...

  const handleCSVEntry = () => {
    return axios
      .post(
        `${baseUrl}/leads`,
        { ...details, override_key: overrideKey },
        {
          headers: { Authorization: AuthStr },
        }
      )
      .then((response) => {
        if (response?.data?.success) {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === "leads",
          });
          queryClient.invalidateQueries({
            queryKey: [details?.campaign_id, "campaign_analytics", token],
          });
          openNotification({
            status: "success",
            message: "Leads Added",
          });
          closeModal();
          location?.pathname === "/campaigns/new" &&
            setTimeout(() => navigate("/campaigns"), 1000);
        }
        return response;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");

        return Promise.reject(
          new Error(e?.response?.data?.message ?? "Something went wrong")
        );
      });
  };

  const mutation = useMutation({
    mutationFn: handleCSVEntry,
    onSuccess: (data) => {
      if (data?.data?.success) {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === "leads",
        });
        openNotification({
          status: "success",
          message: "Leads Added",
        });
        closeModal();
        if (location?.pathname === "/campaigns/new") {
          setTimeout(() => navigate("/campaigns"), 1000);
        }
      }
    },
    onError: (e) => {
      if (e?.message === "Session expired") {
        navigate("/account/logout");
      } else {
        console.error(e);
      }
    },
  });

  useEffect(() => {
    mutation?.reset();
    setError("");
  }, [view]);

  const submit = () => {
    option
      ? option === "all_enter"
        ? mutation.mutate()
        : closeModal()
      : setError("Select an option");
  };

  return (
    <div className="mx-auto overflow-y-auto h-fit customBar bg-background dark:bg-[#2A2C30] border-muted md:w-[471px] w-[96%] flex flex-col gap-[20px] p-[32px] rounded-[8px]">
      <button
        className="absolute top-4 right-4 p-1 rounded-lg z-10 text-gray-400 bg-transparent hover:text-gray-600 dark:hover:text-gray-300"
        onClick={closeModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-[18px]"
        >
          <path
            fillRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div className="flex flex-col gap-[41px]">
        <div className="flex flex-col gap-[41px]">
          <div className="flex flex-col gap-[8px]">
            <p className="font-ibmPlexSerif font-[600] text-primary-dark text-[18px]">
              This contact is in another campaign
            </p>
            <p className="font-switzer text-[#758599] font-[400] text-[14px]">
              Select an option to proceed
            </p>
          </div>
          <div className="flex flex-col gap-[16px]">
            <Radio
              label="Overwrite contact to new campaign"
              labelClassName={labelClassName}
              name="option"
              value="all_enter"
              onChange={(e) => e.target.checked && setOption("all_enter")}
            />
            <Radio
              label="Contact should remain in the old campaign"
              labelClassName={labelClassName}
              name="option"
              value="non_enter"
              onChange={(e) => e.target.checked && setOption("non_enter")}
            />
            {error && (
              <Text className="font-[400] -mt-[8px] text-[12px] text-red font-switzer">
                {error}
              </Text>
            )}
          </div>

          <div className="w-[203px] flex justify-between place-self-end">
            <ActionIcon
              className="text-black dark:!bg-muted dark:text-[#758599] !bg-[#F2F2F2] w-[92px] h-[35px] font-switzer text-[12px] font-[400] rounded-[4px]"
              variant="text"
              onClick={closeModal}
            >
              Cancel
            </ActionIcon>
            <ActionIcon
              className="!text-background !bg-btn w-[92px] h-[35px] font-switzer text-[12px] font-[400] rounded-[4px]"
              isLoading={mutation?.isPending}
              onClick={submit}
            >
              Submit
            </ActionIcon>
          </div>

          {mutation?.error && (
            <Text className="font-[400] text-[12px] text-red font-switzer">
              {mutation?.error?.message}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
}
